export function showError(message) {
  const errorEl = document.querySelector('.js-error-container')

  errorEl.textContent = message
  errorEl.classList.add('active')

  setTimeout(() => {
    errorEl.classList.remove('active')
    errorEl.textContent = ''
  }, 3000)
}